import { Injectable } from '@angular/core';
import { LocalStorageService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class NotificationVisibilityService {
  LastSeenReleaseNote = 'LASTSEENRELEASENOTE';

  constructor(private lStorage: LocalStorageService) { }

  setSeen(id: number): void {
    this.lStorage.set<number>(this.LastSeenReleaseNote, id);
  }

  hasSeen(id: number): boolean {
    const lastSeen = this.lStorage.get<number>(this.LastSeenReleaseNote);
    if (!lastSeen) {
      return false;
    }

    return lastSeen === id;
  }
}
